import React from 'react';
import '../assets/css/loader.css'; // Optional CSS for styling

const Loader = () => {
    return (
        <div className="loader-backdrop">
            <div className="spinner"></div>
        </div>
    );
};

export default Loader;